/** Цели Яндекс Метрики для баннера мобильного приложения, появляющегося над хедером. */
export enum YmGoalMobileAppBanner {
  /** Переход по кнопке на баннере. */
  MobileAppBannerOpen = 'mobileAppBannerOpen',
  /** Закрытие баннера. */
  MobileAppBannerClose = 'mobileAppBannerClose',
}
